import styled from 'styled-components';

import { getThemeColor } from '@utils/styled';

import * as Icons from '@common/components/Icons';
import Typography from '@common/components/Typography';

export const Wrapper = styled.a`
  display: block;
  width: 100%;
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 5)}
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 5)}
  outline: none;
  border-top: 1px solid ${getThemeColor('bluegrey.90')};
  border-bottom: 1px solid ${getThemeColor('bluegrey.90')};
  ${({ theme }) => theme.getFluidSpacing('padding-top', 'scale', 5)}
  ${({ theme }) => theme.getFluidSpacing('padding-bottom', 'scale', 5)}
  background: none;
  color: inherit;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }

  & * {
    pointer-events: none;
  }
`;

export const ContentLoggedIn = styled.span`
  display: grid;
  align-items: center;
  grid-template-columns: auto 1fr auto;
  text-align: left;
  ${({ theme }) => theme.getFluidSpacing('grid-gap', 'equal', 6)}
`;

export const Checkmark = styled(Icons.CheckCircle)`
  fill: ${getThemeColor('hue.green')};
`;

export const ContentLoggedOut = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Text = styled(Typography).attrs({
  customAs: 'span',
  variant: 'body1',
})`
  margin-bottom: 0;
`;

export const TextColored = styled(Text)`
  color: ${getThemeColor('hue.green')};
`;

export const Chevron = styled(Icons.Chevron)`
  transform: rotate(180deg);
  fill: ${getThemeColor('bluegrey.70')};
`;
